const merge = function(o1,o2){
    for(var p in o2){
        o1[p]=o2[p];
    }
    return o1;
};

const extend = (a,b) =>{
    return merge(eval('('+JSON.stringify(a)+')'),eval('('+JSON.stringify(b)+')'))
};
export {merge, extend };